import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AssetStatusCategories } from 'src/app/asset/models/asset.model';
import { PropertySearchResult } from 'src/app/asset/models/property-search-result.model';
import { CacheStorageService } from 'src/app/core/services/data/cache-storage.service';

@Component({
  selector: 'app-property-asset',
  templateUrl: './property-asset.component.html',
  styleUrls: ['./property-asset.component.scss']
})
export class PropertyAssetComponent implements OnInit {
  @Input() selectedProperty: PropertySearchResult;
  @Output() closeFilteredAssetsByProperty = new EventEmitter();
  public version: string = new Date().toString();
  assetStatusCategoriesEnum: typeof AssetStatusCategories = AssetStatusCategories;
  constructor(
    private router: Router,
    private cacheStorageService: CacheStorageService
  ) { }
  ngOnInit(): void {
  }
  tabClicked(event: any) { }
  closeResult() {
    this.closeFilteredAssetsByProperty.emit();
  }
  ViewPropertyDetails(propertyId: string) {
    var isPlaceEnabled = this.cacheStorageService.isPalaceEnable;
    if (propertyId != null) {
      if (window.location !== window.parent.location) {        
        this.router.navigate(['asset/property-detail', propertyId]);        
      }
      else {      
        const url = this.router.serializeUrl(
          this.router.createUrlTree(['asset/property-detail', propertyId], {
              queryParams: { palaceEnabled: isPlaceEnabled }
          }));
    
          window.open(url, '_blank');      
      }
    }
  }
}